<div class="card user-card">
  <div class="card-header">
    <h5>Profile</h5>
  </div>
  <div class="card-block">
    <div>
      <img
        *ngIf="profile.image"
        [src]="profile.image"
        class="profile-user-img"
        alt="User-Profile-Image"
      />
      <img
        *ngIf="!profile.image"
        [src]="defaultUserImg"
        class="profile-user-img"
        alt="User-Profile-Image"
      />
    </div>
    <h6 class="f-w-600 m-t-25 m-b-10">{{ profile.username }}</h6>
    <div>
      <button
        [routerLink]="['/settings']"
        [hidden]="!isUser"
        type="button"
        class="btn btn-primary"
      >
        <i class="icofont icofont-ui-settings"></i> Settings
      </button>
      <follow-button
        *ngIf="profile.isFollowing"
        [hidden]="isUser"
        [profile]="profile"
        (click)="setProfileFollowing($event)"
        >{{ profile.username }}
      </follow-button>
    </div>

    <div class="bg-c-blue counter-block m-t-10 p-20">
      <div class="row">
        <div class="col-4">
          <i class="ti-microphone"></i>
          <p>{{ profile.discussionCount }}</p>
          <p>nDabas</p>
        </div>
        <div class="col-4">
          <i class="ti-flag-alt"></i>
          <p>{{ profile.communityCount }}</p>
          <p>uMuzis</p>
        </div>
        <div class="col-4">
          <i class="ti-user"></i>
          <p>{{ profile.followerCount }}</p>
          <p>followers</p>
        </div>
      </div>
    </div>
    <p [innerHTML]="profile.bio" class="m-t-15 text-muted text-left"></p>
  </div>
</div>
